<template>
  <!-- 表单预览
      @author liuguisheng
      @date 2019-9-14  
   -->
  <div class="dialog-preview">
    <!-- 骨架屏组件 -->
    <skeleton :loading="formLoading"
              :row="12"></skeleton>
    <!-- 表单 -->
    <div v-show="!formLoading">
      <!-- 表单为空 -->
      <div v-if="showEmptyContent" class="preview-enpty">暂无内容</div>
      <el-form  v-else
                ref="previewForm" onsubmit="return false"
                :size="formSettingState.componentSize"
                @hook:mounted="formMounted"
                :model="formModels">

        <template v-show="itemManage==='group'">
          <preview-item-template v-for="(item) in cutDomainNodeList.one"
                                :key="item.id"
                                :formNode="item"
                                :parent="cutDomainNodeList.one">
          </preview-item-template>
        </template>
        <template v-show="itemManage==='group' && formLoadingTwo">
          <preview-item-template v-for="(item) in cutDomainNodeList.two"
                                :key="item.id"
                                :formNode="item"
                                :parent="cutDomainNodeList.two">
          </preview-item-template>
        </template>
         <template v-show="itemManage==='group' && formLoadingThree">
          <preview-item-template v-for="(item) in cutDomainNodeList.three"
                                :key="item.id"
                                :formNode="item"
                                :parent="cutDomainNodeList.three">
          </preview-item-template>
        </template>
        <template v-show="!formLoading">
          <preview-item-template v-for="(item) in formList"
                                :key="item.id"
                                :formNode="item"
                                :parent="formList">
          </preview-item-template>
        </template>
      </el-form>
      <!-- 勾选确定按钮 -->
      <div v-if="itemPickControl" class="pick-button">
        <el-button type="primary" @click="sendPickData">确定勾选</el-button>
        <el-button @click="resetPickData">取消勾选</el-button>
      </div>
    </div>
  </div>
</template>

<script>
/** 混入方法 ::: 
 *  @mixin mixFormPreviewsStore 表单预览组件混入
 */
import { mixRicePreviewFormStore } from "@/mixins/rice_preview_form/mix_rice_preview_form.js";
/** 工具方法 ::: 
 *  @function deepCopy 深拷贝方法
 *  @function upgrade 配置升级方法
 */
import { deepCopy } from "@/utils/utils.js";
import { upgrade } from "@/assets/version/version.js";
// 导入项目配置文件
const packageConfig = require('../../../package.json');


/** @name 表单预览组件
 *  @param {Object} formModel 表单填写数据
 *  @param {Object} formData 表单模版相关数据
 *    - {Array} domainList 领域模版列表
 *    - {Array} formList 表单项模版列表
 *    - {Object} eventMap 事件字典数据
 *  @param {Boolean} itemPick 表单项提取控制开关
 *  @param {Object} pickList 勾选的表单项列表
 *  @function validate 对整个表单内容进行校验
 */
export default {
  name: "RicePreviewForm",
  mixins: [ mixRicePreviewFormStore ],
  model: {
    prop: "formModel",
    event: "refurbishModel",
  },
  props: {
    // 表单填写数据
    formModel: {
      type: Object,
      default: () => ({})
    },
    // 表单数据
    formData: {
      type: Object,
      default: () => ({})
    },
    // 表单项提取控制开关
    itemPick: {
      type: Boolean,
      default: false
    },
    // 勾选的表单项列表
    pickList: {
      type: Object,
      default: () => ({})
    },
    // 是否开启获取第一个可视元素
    startNonius: {
      type: Boolean,
      default: true
    },
    // 切换清空model
    toggleClearModel: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      itemManage: 'none',       // 模版类型  { 'group':启用分组的模版 }
      formPositionList: [],     // 表单项位置字典  { 表单项id:距离顶部位置 }
      formLoading: true,
      formLoadingTwo: false,
      formLoadingThree: false
    }
  },
  computed: {
    cutDomainNodeList () {
      let { domainNodeList } = this;
      let length = domainNodeList.length;
      if ( length <= 4 ) {
        return {
          one: domainNodeList
        }
      }else {
        return {
          one: domainNodeList.filter((el, index) => index <=2 ),
          two: domainNodeList.filter((el, index) => index>2 && index <=5 ),
          three: domainNodeList.filter((el, index ) => index > 5)
        }
      }
    },
    /** @name 模块组件节点列表
     *  @return {Array} 模块节点列表
     *  @author 王汝鹏
     *  @version 2019-12-27
     */
    domainNodeList() {
      return this.domainList.map(domain => this.domainManager(domain).getNode());
    },
    /** @name 空展示列表
     *  @return {Boolean} {true:显示空内容，false:显示表单内容}
     *  @author 王汝鹏 
     *  @version 2019-12-27
     */
    showEmptyContent() {
      return this.itemManage==='group'
        ? ((this.domainNodeList.length === 0) && (this.formList.length === 0))
        : (this.formList.length === 0);
    },
    /**
     * @name 需要向外提交的数据
     * @return { Object } 需要向外提交的表单项数据
     * @author liuguisheng
     * @version 2019-12-29
    */
    emitFormDate() {
      return {
        version: packageConfig.version,
        itemManage: this.itemManage,
        domainList: this.domainList,
        formList: this.formList,
        formMap: this.formMap,
        eventMap: this.eventMap,
        variableMap: this.variableMap
      }
    },
  },
  methods: {
    /** @name 向外传递勾选的表单项数据
     *  @returns { void }
     *  @author liuguisheng
     *  @version 2019-12-11
     */
    sendPickData() {
      // 向外抛出勾选数据
      this.$emit('getPickData', this.pickListState)
    },
    /** @name 对整个表单进行校验
     *  @author 王汝鹏
     *  @version 2019-12-18
     */
    validate() {
      return this.$refs['previewForm'].validate();
    },
    /** @name 重置勾选内容
     *  @author liuguisheng
     *  @version 2019-12-26
     */
    resetPickData() {
      // 清空store
      this.pickListState = {};
    },
    /** @name 获取html元素距离浏览器窗口顶部距离
     *  @description 因为offsetTop只能获取元素相对于父级元素顶部的距离所以需要递归的进行计算
     *  @param {Element} element html元素
     *  @return {Number} 元素距离顶部距离
     *  @author 王汝鹏
     *  @version 2020-01-17
     */
    getElementTop(element) {
      let actualTop = element.offsetTop;
      let current = element.offsetParent;

      while (current !== null) {
        actualTop += current.offsetTop;
        current = current.offsetParent;
      }

      return actualTop;
　　},
    /** @name 获取预览区所有表单项元素位置 
     *  @description 记录所有表单项元素距离顶部的距离存储到formPositionMap中
     *  @author 王汝鹏
     *  @version 2020-01-17
     */
    getElementsOpsition() {
      let currentElementTop = this.getElementTop(this.$el);
      let inputs = this.$el.getElementsByClassName('form-preview');
      let formPositionList = [];
      for (let input of inputs) {
        if (/id-\w+/.test(input.className)) {
          let formClassId = input.className.match(/id-\w+/)[0];
          formPositionList.push({
            id: formClassId,
            position: this.getElementTop(input) - currentElementTop
          })
        }
      }
      this.formPositionList = formPositionList;
    },
    /** @name 查找第一个在可视区的元素
     *  @author 王汝鹏
     *  @version 2020-01-17
     */
    findFirstElement() {
      // 滚动条距离顶部距离
      let scrollTop = this.$el.scrollTop;
      // 找到第一个可视元素索引
      let firstElement = this.formPositionList.find(i => i.position >= scrollTop);
      if (firstElement) {
        this.$emit("firstElement", firstElement.id);
      }
    },
    /**
    * @name 表单加载完毕
    * @return { void }
    * @author liuguisheng
    * @version 2020-08-11 11:15:46 星期二
    */
    formMounted () {
      setTimeout(() => { this.formLoading = false },  500);
      setTimeout(() => { this.formLoadingTwo = true },  700);
      setTimeout(() => { this.formLoadingThree = true },  900);
    }
  },
  mounted() {
    // 填写表单渲染完成，去掉所有的校验状态
    setTimeout(() => { this.$refs['previewForm'] && this.$refs['previewForm'].resetFields && this.$refs['previewForm'].resetFields(); }, 500)
    // 如果开启获取元素位置的功能，记录获取所有元素与位置
    if (this.startNonius) { 
      setTimeout(() => { 
        this.getElementsOpsition(); 
        this.$el.onscroll = this.findFirstElement;
      }, 1000); 
    }
  },
  watch: {
    /** @name 表单填写数据
     *  @description store中表单填写数据发生改变，更新外部的表单数据
     *  @param {Object} newValue 更新后的表单填写变量
     *  @author 王汝鹏
     *  @version 2019-11-11
     */
    formModels: { 
      handler ( newValue ) {
        this.$emit('refurbishModel', newValue)
      },
      deep: true
    },
    /** @name 表单填写数据
     *  @description 外部传入表单填写数据，更新store中表单填写数据
     *  @param {Object} newValue 更新后的表单
     *  @author 王汝鹏
     *  @version 2019-11-09
     */
    formModel: {
      handler(newValue) { this.formModels = newValue; },
      immediate: true
    },
    /** @name 表单模板数据
     *  @param {Object} newValue 更新后的数据
     *  @author 王汝鹏
     *  @version 2019-11-11
     */
    formData: {
      handler(newValue) {
        // 升级模版配置
        let upgradeValue = {};
        try {
          upgradeValue = upgrade(newValue);
          //  更新store数据
          this.importTemplateConfig(upgradeValue);
          // console.log('配置升级:: ', formData, upgradeValue);
        } catch(error) {
          // console.log("配置升级错误:: ",  formData);
        }
      },
      immediate: true
    },
    /** @name 表单项提取控制开关监听
     *  @param { Boolean } value 表单项提取开关
     *  @author liuguisheng
     *  @version 2019-12-10
     */
    itemPick: {
      handler(newValue) { this.itemPickControl = newValue; },
      immediate: true,
    },
    /** @name 勾选的表单项监听
     *  @param { Array } newValue 勾选的表单项集合
     *  @author liuguisheng
     *  @version 2019-12-10
     */
    pickList: {
      handler(newValue) { this.pickListState = newValue; },
      immediate: true
    },
   /** @name 表单项更新向外提交
    *  @returns { void }
    *  @author liuguisheng
    *  @version 2019-12-28
    */
    formMap: {
      handler() { 
        this.$emit('getUpdateData', this.emitFormDate); 
        this.$nextTick(() => { this.getElementsOpsition(); });
      },
      immediate: true,
      deep: true
    },
    /**
    * @name 切换选项是否清空model
    * @description 
    * @params {}
    * @return { void }
    * @author liuguisheng
    * @version 2020-06-15 17:13:34 星期一
    */
    toggleClearModel: {
      handler ( newValue ) {
        this.toggleClearModelState = newValue
      },
      immediate: true
    }
  }
}
</script>
<style lang="scss">
@import "../../../src/style/index.scss";
</style>


// WEBPACK FOOTER //
// packages/RicePreviewForm/src/RicePreviewForm.vue